import AttachesTool from '@editorjs/attaches'

export default class extends AttachesTool {
  constructor(data, config, api) {
    super(data, config, api)
  }
  uploadingFailed(errorMessage) { 
    // skipping error message https://github.com/editor-js/attaches/blob/master/src/index.js#L457
    this.removeLoader();
  }
}
